import { client } from './client';
import type { ApiResponse } from '@/types/api';
import type { TimelineResponse } from '@/types/timeline';

export interface TimelineParams {
  cursor?: string;
  limit?: number;
}

export async function getTimeline(
  studentId: string,
  params?: TimelineParams,
): Promise<TimelineResponse> {
  const { data } = await client.get<ApiResponse<TimelineResponse>>(
    `/api/v1/dashboard/students/${studentId}/timeline`,
    { params },
  );
  return data.data;
}
